import React, { FC } from "react";
import classNames from "classnames";
import { useTranslations } from "next-intl";

import { CustomRadioButton, ShowWhen } from "@/components/common";
import { BuyForYouIcon } from "@/components/assets/icons";
import { TBuyForYouProps } from "../types";

const BuyForYou: FC<TBuyForYouProps> = ({ isSelected, onClick, totalCost }) => {
  const t = useTranslations();

  return (
    <>
      <div
        className={classNames(
          "mt-7 flex h-[62px] w-fit cursor-pointer items-center rounded-[35px] border-2 p-[8px] pr-4",
        )}
        onClick={onClick}
      >
        <div className="flex w-full items-center justify-between gap-2">
          <div
            className={classNames(
              "flex h-[2.87rem] w-[2.87rem] items-center justify-center rounded-full bg-[#F9F9F9] p-3",
            )}
          >
            <BuyForYouIcon />
          </div>
          <div>
            <p className="text-sm font-semibold text-black">
              {t("buy_for_you")}
            </p>
          </div>
          <CustomRadioButton
            id="buyForYou"
            name="checkbox"
            selected={isSelected}
            onChange={onClick}
          />
        </div>
      </div>
      <ShowWhen condition={!!isSelected}>
        <p className="mt-[10px] text-xs font-medium text-[#6d6d6d]">
          for the service: {totalCost || 0}$
        </p>
      </ShowWhen>
    </>
  );
};

export { BuyForYou };
